exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueCarousel-dot:focus{outline:none!important}@media (max-width:1366px){.VueCarousel-pagination{width:100%;text-align:center;margin-top:-123px;z-index:10}button:first-child.VueCarousel-dot.VueCarousel-dot--active{background-color:#3a3a3a!important}}@media (max-width:1360px){.VueCarousel-pagination{display:none!important}}", ""]);

// exports
